import { useNavigate } from "react-router-dom";
import { DeleteIcon, EditIcon } from "../../assets/icons/Svgs";
import { eliminarEstudiante } from "../../services/estudiante.service";
import {
  showDeletedAlert,
  showErrorAlert,
  showQuestionDeleteAlert,
  showUpdateAlert,
  showAlertDescongelar,
} from "../../components/molecules/ShowAlert";

const formatearFecha = (fecha) => {
  if (!fecha) return "N/A";
  const date = new Date(fecha);
  return isNaN(date) ? "N/A" : date.toLocaleDateString("es-ES");
};

export const EstudianteReprobadoCard = ({ estudiante, index, onDelete }) => {
  const navigate = useNavigate();

  const {
    estudiante: datosEst = {},
    persona = {},
    inscripcion = {},
    registro = {},
  } = estudiante || {};

  const {
    tipoAdmision = "N/A",
    idEstudiante,
  } = datosEst;

  const {
    nombre = "",
    apellido = "",
    celular = "_",
  } = persona;

  const {
    programa = {},
  } = inscripcion;

  const {
    grupo = {},
    tipoCongelacion = "",
    fechaReprobado,
  } = registro;

  const nombrePrograma = programa?.nombre || "N/A";
  const nombreGrupo = grupo?.nombre || "N/A";
  const moduloReprobado = grupo?.modulo?.nombre || "N/A";
  const fechaReprobadoFormatted = formatearFecha(fechaReprobado);

  const congelado = tipoCongelacion.trim().toLowerCase();
  const estaCongelado = congelado === "voluntario" || congelado === "institucional";

  const handleDelete = async () => {
    showQuestionDeleteAlert({
      callback: async (result) => {
        if (!result.isConfirmed) return;
        try {
          await eliminarEstudiante(idEstudiante);
          showDeletedAlert({
            callback: () => onDelete?.(idEstudiante),
          });
        } catch (error) {
          console.error("Error al eliminar el estudiante:", error);
          showErrorAlert({});
        }
      },
    });
  };

  const handleUpdate = () => {
    showUpdateAlert({
      callback: () => {
        navigate(`/estudiantes/actualizar/${idEstudiante}`);
      },
    });
  };

  const handleAsignarModulo = () => {
    if (estaCongelado) {
      showAlertDescongelar({
        icon: "warning",
        text: `No puedes asignar módulo al estudiante ${nombre} ${apellido} mientras esté congelado (${tipoCongelacion}). Debes descongelarlo.`,
      });
      return;
    }

    navigate(`/asignar-modulo/${idEstudiante}`, {
      state: { estudiante },
    });
  };

  return (
    <tr className="bg-white hover:bg-gray-100 transition-colors duration-300 [&>td]:p-3 [&>td]:text-gray-700 [&>td]:whitespace-nowrap">
      <td className="font-medium border-r border-slate-200 border-t">{index + 1}</td>
      <td className="border-r border-slate-200 border-t">{nombre}</td>
      <td className="border-r border-slate-200 border-t">{apellido}</td>
      <td className="border-r border-slate-200 border-t">{celular}</td>
      <td className="border-r border-slate-200 border-t">{tipoAdmision}</td>
      <td className="border-r border-slate-200 border-t">{nombrePrograma}</td>
      <td className="border-r border-slate-200 border-t">{nombreGrupo}</td>
      <td className="border-r border-slate-200 border-t">{moduloReprobado}</td>
      <td className="border-r border-slate-200 border-t">{fechaReprobadoFormatted}</td>
      <td className="border-slate-200 border-t">
        <div className="flex justify-start gap-4">
          <button
            onClick={handleAsignarModulo}
            className={`font-semibold transition-colors py-1 px-4 rounded-lg shadow-md ${
              estaCongelado
                ? "bg-gray-400 cursor-not-allowed text-white"
                : "bg-theme-yellow hover:bg-yellow-500 text-white"
            }`}
          >
            Asignar módulo
          </button>

          <button onClick={handleUpdate} className="bg-green-500 p-1 rounded-md text-white">
            <EditIcon className="w-5 h-5" />
          </button>

          <button onClick={handleDelete} className="bg-red-500 p-1 rounded-md text-white">
            <DeleteIcon className="w-5 h-5" />
          </button>
        </div>
      </td>
    </tr>
  );
};
